let axios = require('axios')

const youtube = 'https://www.googleapis.com/youtube/v3/search'

module.exports = function(options, callback) {
  if (!options.apiKey) {
    throw new Error('Youtube search requires a key')
  }

  let params = {
    part: 'snippet',
    key: options.apiKey,
    q: options.term,
    maxResults: options.items ? options.item : 5,
    type: 'video'
  }
  axios
    .get(youtube, { params })
    .then(response => {
      if (callback) {
        callback(response.data.items)
        let videos = response.data.items
        console.log(videos)
        return videos
      }
    })
    .catch(error => console.error(error))
}
